import  "./Greek2023.css"

const Greek2023 = ()=>{
    
    return (
    <>        
     
    </>
    )
}

export default Greek2023;